module.exports = __webpack_public_path__ + "static/media/react.c3fbd71b.svg";